
import "whatwg-fetch"
import Pensioendetails from "pages/Pensioendetails.vue"
import store from "store/index"
import Vue from "vue"

import options from "i18n/nl-NL"
import i18n from "lib/i18n/install"

Vue.use(i18n, options)

/* tslint:disable:no-unused-expression */
new Vue({
	components: {
		Pensioendetails
	},
	el: "#app",
	store,
	template: '<div id="app"><Pensioendetails v-cloak></Pensioendetails></div>'
})
